import script from "./PwaSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaSettings.vue?vue&type=script&setup=true&lang=ts"

import "./PwaSettings.vue?vue&type=style&index=0&id=01429c9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01429c9a"]])

export default __exports__